import { StorePagination } from "../../../../DashboardPagination"
import { orderActions } from "../../../../../store/orders-slice"

const Pagination = ({ index }) => {
    return <StorePagination index={index} sliceName="order" actions={orderActions} label="Bestellungen Seitennavigation" />
}

export default Pagination;
